import axios from 'axios'

import config from '../../config'

const updateCondition = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Conditions`
  return axios.put(url, data)
}

export default updateCondition
